import { Icon } from "@chakra-ui/react"

export const VisiblityShow = (props: any) => (
  <Icon version="1.1" id="Layer_1" x="0px" y="0px"
     viewBox="0 0 242.37 180.79">
    <g>
      <g id="Group_1150" transform="translate(10.891 7.27)">
        <g id="Group_1149">
          <path id="Path_557" d="M136.86,59.32c-1.78-1.78-4.65-1.78-6.43,0s-1.78,4.65,0,6.43
            c10.64,10.59,10.72,27.79,0.13,38.47c-10.59,10.64-27.79,10.72-38.47,0.13c-0.04-0.04-0.09-0.09-0.13-0.13
            c-1.78-1.78-4.65-1.78-6.43,0c-1.78,1.78-1.78,4.65,0,6.43c6.77,6.82,16.02,10.64,25.61,10.64c20.01,0,36.25-16.24,36.25-36.25
            C147.54,75.34,143.72,66.1,136.86,59.32z"/>
        </g>
      </g>
      <g id="Group_1152" transform="translate(9.651 6.032)">
        <g id="Group_1151">
          <path id="Path_558" d="M118.78,50.54c-19.45-3.69-38.25,9.07-41.94,28.52c-0.43,2.34-0.65,4.73-0.65,7.12
            c0.04,2.13,0.26,4.25,0.65,6.34c0.35,2.17,2.26,3.73,4.43,3.78c0.26,0,0.52,0,0.82-0.09c2.47-0.43,4.08-2.74,3.69-5.21v-0.04
            c-0.3-1.56-0.48-3.17-0.48-4.73c0-15.02,12.16-27.18,27.18-27.18c1.61,0,3.17,0.17,4.73,0.48c2.47,0.43,4.82-1.22,5.25-3.69
            C122.91,53.36,121.26,50.98,118.78,50.54L118.78,50.54z"/>
        </g>
      </g>
      <g id="Group_1154" transform="translate(7.547 4.098)">
        <g id="Group_1153">
          <path id="Path_559" d="M222.28,85.19c-16.89-19.1-36.99-35.12-59.35-47.32c-2.21-1.17-4.95-0.26-6.12,1.95
            c-1.17,2.21-0.26,4.95,1.95,6.12c20.14,11.07,38.38,25.31,54.01,42.2c-10.81,11.72-53.36,54.4-98.16,54.4
            c-15.8-0.13-31.39-3.91-45.59-10.94c-2.26-1.09-4.95-0.13-6.03,2.13c-1.09,2.26-0.13,4.95,2.13,6.03l0,0
            c15.41,7.64,32.34,11.68,49.49,11.85c55.87,0,105.63-58.05,107.71-60.52C223.76,89.36,223.72,86.89,222.28,85.19z"/>
        </g>
      </g>
      <g id="Group_1156" transform="translate(0 2.413)">
        <g id="Group_1155">
          <path id="Path_560" d="M151.87,31.55c-9.55-3.34-19.62-5.08-29.74-5.21c-55.83,0-105.58,58.05-107.71,60.52
            c-1.35,1.56-1.43,3.82-0.26,5.51c11.5,15.41,25.57,28.74,41.59,39.42c0.74,0.48,1.61,0.74,2.52,0.74
            c2.47,0.04,4.56-1.91,4.6-4.43c0.04-1.56-0.78-3.04-2.08-3.91c-14.02-9.46-26.48-20.97-36.99-34.21
            c10.42-11.33,53.23-54.62,98.42-54.62c9.16,0.13,18.23,1.74,26.83,4.73c2.34,0.82,4.91-0.43,5.73-2.78v-0.04
            c0.78-2.34-0.48-4.91-2.82-5.73C151.92,31.59,151.87,31.59,151.87,31.55z"/>
        </g>
      </g>
      <g id="Group_1158" transform="translate(3.62)">
        <g id="Group_1157">
          <path id="Path_561" d="M198.74,11.98c-1.74-1.78-4.6-1.78-6.38-0.04l-0.04,0.04L38.2,166.1
            c-1.78,1.78-1.78,4.65,0,6.43c1.78,1.78,4.65,1.78,6.43,0l0,0L198.7,18.4C200.52,16.62,200.57,13.76,198.74,11.98
            C198.79,11.98,198.79,11.98,198.74,11.98z"/>
        </g>
      </g>
    </g>
  </Icon>
);
